import { sendUserSentMessageState, updateVisitHistory } from './utils';

const ALLOWED_ORIGINS = [
    process.env.REACT_APP_BASE_URL,
];

export const handleConsoleTourMessage = (e, {
    setIsStreaming,
    setIsChatbotPending,
    sendInputFocusStatus,
    currentPage,
    setIsInConsoleTour,
    clearExamples,
    sendMessageWithWebSocket
}) => {
    if (!ALLOWED_ORIGINS.includes(e.origin)) return;

    const { type } = e.data;
    switch (type) {
        case "sendSampleText": {
            setIsStreaming(true);
            sendUserSentMessageState(true);
            sendMessageWithWebSocket({ 
                messageInput: '어제 주문했는데, 배송이 언제 완료돼?',
                isChatbot: false, 
                preAnswers: [],
                streamType: 'tour-sendSampleText'
            });
            setIsChatbotPending(true);
            sendInputFocusStatus(true);
            clearExamples();
            updateVisitHistory(currentPage);
            break;
        }
        case "enterGentooRequest":
            setIsInConsoleTour(true);
            break;
        case "enterGentooFeedback":
            setIsStreaming(true);
            sendMessageWithWebSocket({
                messageInput: '지금 내용을 유지하고, 보통 배송은 1~2일 소요되지만 천재지변으로 인해 배송이 지연될 수도 있다는 내용도 보완해줘.',
                isChatbot: false,
                preAnswers: [],
                streamType: 'tour-enterGentooFeedbackDone'
            });
            setIsChatbotPending(true);
            sendInputFocusStatus(true);
            updateVisitHistory(currentPage);
            break;
        default:
            return;
    }
}; 